import axios from 'axios'

import type { AxiosInstance } from 'axios'

const apiExternalStorage: AxiosInstance = axios.create()

export default apiExternalStorage
